import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-select-option" }


const __default__ = {
  name: 'CSelectOption'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
  value: string | number,
  title: string
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})